import {
  Box,
  DividerProps,
  Divider as MUIDivider,
  useTheme,
} from '@mui/material';
import React from 'react';

const Divider: React.FC<DividerProps> = ({ children, style, ...restPrps }) => {
  const theme = useTheme();
  return (
    <MUIDivider
      data-testid='divider'
      sx={{
        borderColor: theme.palette.grey[500],
        color: theme.palette.grey[500],
        '&:before': { borderColor: theme.palette.grey[500] },
        '&:after': { borderColor: theme.palette.grey[500] },
        ...style,
      }}
      variant='fullWidth'
      {...restPrps}
    >
      {children && <Box mx={4}>{children}</Box>}
    </MUIDivider>
  );
};

export default Divider;
